export type CustomAttributeType =
  | 'dropdown'
  | 'text'
  | 'date-picker'
  | 'radio-button';

export interface ITextFieldConfig {
  charLimit: number;
  isEditable: boolean;
  isHighlightable: boolean;
  isExceedable: boolean;
}

export interface ICustomAttributeOption {
  _id: string;
  keyName: string;
  aliasName?: string;
  lableId?: string;
  type: CustomAttributeType;
  isLable: false;
  isActive: boolean;
  isChecked?: boolean;
}

export interface ICustomAttributeMaster {
  _id: string;
  keyName: string;
  aliasName?: string;
  refName?: string;
  type: CustomAttributeType;
  isLable: boolean;
  lableId?: string;
  isDeleted?: boolean;
  isActive: boolean;
  isChecked?: boolean;
  seqNumber?: number;
  textFieldConfig?: ITextFieldConfig;
  productType?: string[];
  brand?: string[];
  values?: ICustomAttributeOption[];
  isEmpty?: boolean;
  isUsedProductType?: string[];
  isUsedBrand?: string[];
}

export interface IDynamicColumnValue {
  colId: string;
  valueId: string | null;
  valueText: string;
}

export interface IDateFilter {
  from: string | null;
  to: string | null;
}

export interface IRadioFilter {
  optionIds: string[];
}

/**
 * Maximum number of characters an admin may configure on a text custom attribute,
 * and the value a newly added text attribute starts at. Every consumer reads the
 * stored `textFieldConfig.charLimit`, so this ceiling is enforced here alone.
 */
export const TEXT_ATTRIBUTE_CHAR_LIMIT_MAX = 100;
